import axiosInstance from '../axiosInterceptor/axiosInstance'

const getOrgUsers = async (orgId) => {
  const url = `v1/orgs/${orgId}/users`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getOrgUsers
